<div 
    class="p-3" 
    appVenueColour 
    [primaryColour]="venue.primaryColour"
>
    <div class="mb-2 d-flex justify-content-between align-items-center">
        <span class="fw-semibold">{{ title || 'Select options' }}</span>
        <button
            type="button"
            class="btn btn-outline-secondary"
            aria-label="Close"
            (click)="closePopover()"
            [disabled]="disabled"
        >
            Close
        </button>
    </div>
    
    <hr class="m-0 mb-3"/>

    @if (isRequired) {
        <button
            data-testid="none-option"
            type="button"
            class="btn w-100"
            [class.btn-primary]="noneSelected"
            [class.btn-outline-secondary]="!noneSelected"
            [attr.aria-pressed]="isSelected('None')"
            (click)="selectNone()"
            [disabled]="disabled"
        >
            We have no dietary restrictions
        </button>
        <hr class="my-2 border-dark-subtle"/>
    }
    
    <div
        class="d-flex flex-wrap gap-2"
        style="max-height: 50vh; overflow-y: auto;"
        data-testid="dietary-restrictions-options"
    >
        <button
            *ngFor="let option of sortedOptions"
            type="button"
            class="btn btn-sm"
            [class.btn-primary]="isSelected(option)"
            [class.btn-outline-secondary]="!isSelected(option)"
            [attr.aria-pressed]="isSelected(option)"
            (click)="toggleOption(option)"
            [disabled]="disabled"
        >
            {{ option }}
        </button>
    </div>
    
    <div class="mt-3 d-flex gap-2 justify-content-end">
        <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            (click)="clear()"
            [disabled]="disabled"
        >
            Clear All
        </button>
    </div>
</div>
